




















































































































































import {
  defineComponent,
  watch,
  computed,
  toRefs,
  ref,
  onMounted,
  reactive,
  getCurrentInstance,
} from '@vue/composition-api';
import { SearchIcon, HelpCircleIcon } from 'tdesign-icons-vue';
import _ from 'lodash';
import watermarkHandler from '@/renderer/views/desktop/ManageConsole/Watermark/compositions/watermarkHandler';
import { previewWatermark } from '@/renderer/scripts/utils/watermark/watermark';
import { i18n_t } from '@/locales/i18n';

export default defineComponent({
  components: {
    SearchIcon,
    HelpCircleIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const previewConfig = reactive({
      deviceType: 1,
      userType: 0,
    });
    const showSearchBtn = ref(false);
    const visible = ref(false);
    // 账号体系（账号密码、手机号）
    const onlyPasswordLogin = computed(() => store.getters.onlyPasswordLogin);
    // 是否支持万象（图片预览）
    const enableMediaProcessing = computed(() => store.getters.enableMediaProcessing);
    const username = computed(
      () =>
        `${store.getters.userBaseInfo.nickname} ${
          onlyPasswordLogin.value
            ? store.getters.userBaseInfo.accountName
            : store.getters.userBaseInfo.phoneNumber.substr(-4)
        }`,
    );
    const orgName = computed(() => store.getters.orgName);
    // 预览水印（预览者信息、分享者信息）
    const shareMaskTips = computed(() =>
      onlyPasswordLogin.value ? i18n_t('分享者昵称+用户账号') : i18n_t('分享者昵称+用户手机尾号4位'),
    );
    const preivewMaskTips = computed(() =>
      onlyPasswordLogin.value ? i18n_t('预览者昵称+用户账号') : i18n_t('预览者昵称+用户手机尾号4位'),
    );
    // 支持预览的文件类型
    const enablePreviewFile = computed(() =>
      enableMediaProcessing.value ? i18n_t('图片/文档/视频') : i18n_t('文档/视频'),
    );
    const headerTips = computed(() => {
      const tips1 = i18n_t('用户水印由 {slot1} 组成；企业信息水印为企业名称。', {
        slot1: shareMaskTips.value,
      });
      const tips2 = i18n_t('暂不支持20MB以上图片以及gif、svg格式图像。');
      return enableMediaProcessing.value ? `1. ${tips1} <br/> 2. ${tips2}` : tips1;
    });
    const previewTips = computed(() =>
      i18n_t('开启后，登录用户在预览{slot1}时，文件将平铺展示水印信息。', {
        slot1: enablePreviewFile.value,
      }),
    );
    const downloadTips = i18n_t('开启后，登录用户下载图片时，图片将平铺展示水印信息。<br/>暂不支持文档水印。');
    const shareTips = computed(() => {
      return i18n_t(
        '预览水印支持{slot1}{slot2}<br/>      1.开启分享者信息，会展示分享者信息；<br/>      2.开启预览者信息，会根据账号身份展示水印信息；<br/>      （1）网盘用户：预览者企业名称+{slot3}<br/>      {slot4}3.开启自定义水印，会展示分享者设置水印信息。<br/>',
        {
          slot1: enablePreviewFile.value,
          slot2: enableMediaProcessing.value ? i18n_t('，下载水印仅支持图片') : '',
          slot3: preivewMaskTips.value,
          slot4: onlyPasswordLogin.value ? `` : i18n_t('（2）游客用户：游客+手机号<br/>'),
        },
      );
    });
    const { saveWatermarkConfig, formData, isEqual } = watermarkHandler();
    const confirming = ref(false);
    const methods = {
      onCancel() {
        confirming.value = false;
      },
      onConfirm: () => {
        const $form = vm.$refs?.form as any;
        $form.submit();
        confirming.value = false;
      },
      onSave() {
        if (formData.enableShareWatermark && formData.shareWatermarkType === 0) {
          confirming.value = true;
        } else {
          methods.onConfirm();
        }
      },
      onSubmit() {
        saveWatermarkConfig(formData);
      },
      reverseImgState() {
        visible.value = !visible.value;
        if (previewConfig.deviceType === 0) {
          methods.refreshWatermark('watermark-file-detail-container', 426, 524);
        } else {
          methods.refreshWatermark('watermark-file-detail-container', 376, 454);
        }
      },
      refreshWatermark(idSelector: string, cWidth: number, cHeight: number) {
        const textContent = previewConfig.userType === 0 ? username.value : orgName.value;
        previewWatermark(idSelector, textContent, cWidth, cHeight);
      },
    };

    // 右侧预览水印配置
    watch(previewConfig, val => {
      if (val.deviceType === 0) {
        methods.refreshWatermark('watermark-file-container', 176, 228);
      } else {
        methods.refreshWatermark('watermark-file-container', 158, 190);
      }
    });
    onMounted(() => {
      methods.refreshWatermark('watermark-file-container', 158, 190);
    });
    return {
      visible,
      showSearchBtn,
      username,
      orgName,
      confirming,
      formData,
      isEqual,
      headerTips,
      previewTips,
      downloadTips,
      shareTips,
      enableMediaProcessing,
      ...toRefs(previewConfig),
      ...methods,
    };
  },
});
